import React, { ReactNode } from 'react';
import cx from 'classnames';
import { Pagination } from '@m4b-design/components';
import { useListPanel, UseListPanelOptions } from './index.ViewHook';
import styles from './index.scss';
import { AnchorTo } from '@/pages/SegmentedHomepage/components';
import NoContentPage from '@features/components/no-content-page';

interface ListPanelProps<T = any> extends UseListPanelOptions<T> {
  className?: string;
  header: ReactNode;
  renderItem?: (item: T, index: number, pageNum: number) => ReactNode;
  renderLoading?: (
    total: number,
    pageNumber: number,
    pageSize: number,
  ) => ReactNode;
}

export const ListPanel = <T,>({
  className,
  id,
  header,
  fetch,
  pagination,
  renderItem,
  renderLoading,
}: ListPanelProps<T>) => {
  const {
    loading,
    error,
    pageNumber,
    defaultPageSize,
    total,
    items,
    handleChange,
  } = useListPanel({
    id,
    pagination,
    fetch,
  });

  return (
    <section id={id.toString()} className={cx(styles.ListPanel, className)}>
      <div className={styles.ListPanelHeader}>{header}</div>
      {!error ? (
        <>
          <div className={styles.ListPanelContent}>
            {!loading
              ? items.map((item, index) =>
                  renderItem?.(item, index, pageNumber),
                )
              : renderLoading?.(total, pageNumber, defaultPageSize)}
          </div>
          <Pagination
            className={styles.ListPanelPagination}
            disabled={loading}
            size="mini"
            defaultPageSize={defaultPageSize}
            current={pageNumber}
            total={total}
            onChange={handleChange}
            itemRender={(_, __, originElement) => (
              <>
                <AnchorTo anchor={id.toString()} />
                {originElement}
              </>
            )}
            {...pagination}
          />
        </>
      ) : (
        <NoContentPage className="mt-24 mx-auto" />
      )}
    </section>
  );
};
